import React, { useState } from 'react';

import Sidebar from './Sidebar';
import Topbar from './Topbar';
import './AppShell.css';

const AppShell = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="app-shell">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className="app-shell__main">
        <Topbar onMenuClick={toggleSidebar} />

        <main className="app-shell__content">{children}</main>
      </div>

      {sidebarOpen && <div className="app-shell__overlay" onClick={() => setSidebarOpen(false)} />}
    </div>
  );
};

export default AppShell;
